import { useMemo } from "react";
import { ChartDataItem, PieChartProps } from "../types/dashboard";

export const usePieChartData = ({ Orders = 0, amount = 0, ReceivedAmount = 0, OutstandingAmount = 0, timeRange = "today" }: PieChartProps) => {
  const hasValidData = useMemo(() => [Orders, amount, ReceivedAmount, OutstandingAmount].some((val) => val > 0), [Orders, amount, ReceivedAmount, OutstandingAmount]);

  const chartData: ChartDataItem[] = useMemo(
    () => [
      { name: "Orders", value: Orders, color: "#3b82f6" },
      { name: "Amount", value: amount, color: "#f59e0b" },
      { name: "Received", value: ReceivedAmount, color: "#10b981" },
      { name: "Outstanding", value: OutstandingAmount, color: "#ef4444" },
    ],
    [Orders, amount, ReceivedAmount, OutstandingAmount]
  );

  const noDataMessages = {
    today: "No orders placed today",
    week: "No orders placed this week",
    month: "No orders placed this month",
  };

  const noDataMessage = noDataMessages[timeRange];

  return {
    hasValidData,
    chartData,
    noDataMessage,
  };
};
